import React from 'react';
import './error-indicator.css';

const ErrorIndicator = () => {
  return <h1>Что-то пошло не так.</h1>;
};

export default ErrorIndicator;
